const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUuid = (value) => typeof value === 'string' && UUID_RE.test(value.trim());

/** Map machines.id (UUID) and optional code → { code, name } */
export const buildMachineLookup = (machines = []) => {
  const map = new Map();
  machines.forEach((m) => {
    const code = m?.code || m?.machine_id;
    const entry = { code, name: m?.name };
    if (m?.id != null) map.set(String(m.id), entry);
    if (code) map.set(String(code), entry);
  });
  return map;
};

/** Human-readable fleet code e.g. JCB-001 — never the machines table UUID */
export const getBookingMachineCode = (b, lookup) => {
  if (b?.machines?.machine_id) return b.machines.machine_id;
  if (b?.machine && !isUuid(String(b.machine))) return b.machine;
  const refId = b?.machine_id;
  if (refId != null && lookup) {
    const found = lookup.get(String(refId));
    if (found?.code) return found.code;
  }
  if (refId != null && !isUuid(String(refId))) return String(refId);
  return 'N/A';
};

export const getBookingMachineLabel = (b, lookup) => {
  const code = getBookingMachineCode(b, lookup);
  if (code === 'N/A') return 'N/A';
  const name = b?.machines?.name || b?.machineFull || lookup?.get(String(b?.machine_id))?.name;
  return name && name !== code ? `${code} - ${name}` : code;
};
